import {
    prorataShareIndex,
    reimbCodeIndex,
    reimbursementTypesNo,
    taxesCheckboxCellIndex,
} from "../../utils";

function reimbursementTypeRowForCode(tabs, tab, reimbCodeRaw) {
    const n = parseInt(reimbCodeRaw, 10);
    if (!Number.isFinite(n) || n < 1 || n > reimbursementTypesNo) {
        return null;
    }
    return tabs[tab].tables['reimbursement-types'].rows[n - 1] || null;
}

export default {
    name: 'Property Information',
    tables: {
        'general-information': {
            name: 'PROPERTY INFORMATION',
            rows: {
                'property-name': {
                    name: 'Property Name',
                    editable: true,
                    value: '',
                },
                'address': {
                    name: 'Address',
                    editable: true,
                    value: '',
                },
                'city': {
                    name: 'City',
                    editable: true,
                    value: '',
                },
                'state': {
                    name: 'State',
                    editable: true,
                    type: 'dropdown',
                    dropdownValues: '',
                    value: '',
                },
                'zip': {
                    name: 'ZIP',
                    editable: true,
                    value: '',
                },
                'map-image': {
                    name: 'Map Image',
                    editable: true,
                    value: ''
                },
            }
        },
        'other-information': {
            name: '',
            rows: {
                'total-sq-ft': {
                    name: 'Total Sq Ft',
                    editable: false,
                    getComputedValue(tabs, precomputedValues) {
                        const value = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' : `${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'year-built': {
                    name: 'Year Built',
                    editable: true,
                    type: 'number',
                    value: '',
                },
                'lot-size': {
                    name: 'Lot Size (acres)',
                    editable: true,
                    type: 'number',
                    unit: 'Acres',
                    value: '',
                },
                'current-tax-appraised-value': {
                    name: 'Current Tax Appraised Value',
                    editable: true,
                    type: 'number',
                    unit: '$',
                    value: '',
                },
                'current-tax-liability': {
                    name: 'Current Tax Liability',
                    editable: true,
                    type: 'number',
                    unit: '$',
                    value: '',
                },
                'mill-rate': {
                    name: 'Mill Rate',
                    editable: false,
                    tooltip: ' = current_tax_liability / current_tax_appraised_value',
                    getComputedValue(tabs, precomputedValues) {
                        const currentTaxAppraisedValue = tabs['property-information-tab'].tables['other-information'].rows['current-tax-appraised-value'].value;
                        const currentTaxLiability = tabs['property-information-tab'].tables['other-information'].rows['current-tax-liability'].value;
                        const value = parseFloat((currentTaxLiability / currentTaxAppraisedValue * 100).toFixed(2));
                        const displayValue = !value || isNaN(value) ? '-' : `${value.toFixed(2).toLocaleString()}%`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'new-assessed-value': {
                    name: 'New Assessed Value',
                    editable: false,
                    tooltip: ' = pricing_value',
                    getComputedValue(tabs, precomputedValues) {
                        const value = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'new-taxes': {
                    name: 'New Taxes',
                    editable: false,
                    tooltip: ' = new_assessed_value * mill_rate',
                    getComputedValue(tabs, precomputedValues) {
                        const millRate = tabs['property-information-tab'].tables['other-information'].rows['mill-rate'].getComputedValue(tabs, precomputedValues).internalValue;
                        const newAssessedValue = tabs['property-information-tab'].tables['other-information'].rows['new-assessed-value'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((newAssessedValue * millRate / 100).toFixed(2));
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'new-taxes-PSF': {
                    name: 'New Taxes PSF',
                    editable: false,
                    tooltip: ' = new_taxes / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const totalSqFt = tabs['property-information-tab'].tables['other-information'].rows['total-sq-ft'].getComputedValue(tabs, precomputedValues).internalValue;
                        const newTaxes = tabs['property-information-tab'].tables['other-information'].rows['new-taxes'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((newTaxes / totalSqFt).toFixed(2));
                        const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'increase-in-taxes': {
                    name: 'Increase in Taxes',
                    editable: false,
                    tooltip: ' = new_taxes / current_tax_liability',
                    getComputedValue(tabs, precomputedValues) {
                        const currentTaxLiability = tabs['property-information-tab'].tables['other-information'].rows['current-tax-liability'].value;
                        const newTaxes = tabs['property-information-tab'].tables['other-information'].rows['new-taxes'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = newTaxes - currentTaxLiability;
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'increase-psf-in-taxes': {
                    name: 'Increase PSF in Taxes',
                    editable: false,
                    tooltip: ' = increase_in_taxes / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const totalSqFt = tabs['property-information-tab'].tables['other-information'].rows['total-sq-ft'].getComputedValue(tabs, precomputedValues).internalValue;
                        const increaseInTaxes = tabs['property-information-tab'].tables['other-information'].rows['increase-in-taxes'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((increaseInTaxes / totalSqFt).toFixed(2));
                        const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'average-size-of-space': {
                    name: 'Average Size of Space',
                    editable: false,
                    tooltip: ' = total_sq_ft / tenants_count',
                    getComputedValue(tabs, precomputedValues) {
                        const totalSqFt = tabs['property-information-tab'].tables['other-information'].rows['total-sq-ft'].getComputedValue(tabs, precomputedValues).internalValue;
                        const tenantsCount = tabs['current-rr-tab'].tables['sumed-general-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseInt(totalSqFt / tenantsCount);
                        const displayValue = !value || isNaN(value) ? '-' : `${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'average-increase-in-taxes-per-year': {
                    name: 'Average Increase in Taxes per Year',
                    editable: false,
                    tooltip: ' = increase_psf_in_taxes * average_size_of_space',
                    getComputedValue(tabs, precomputedValues) {
                        const increasePsfInTaxes = tabs['property-information-tab'].tables['other-information'].rows['increase-psf-in-taxes'].getComputedValue(tabs, precomputedValues).internalValue;
                        const averageSizeOfSpace = tabs['property-information-tab'].tables['other-information'].rows['average-size-of-space'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((increasePsfInTaxes * averageSizeOfSpace).toFixed(2));
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'average-increase-in-taxes-per-month': {
                    name: 'Average Increase in Taxes per Month',
                    editable: false,
                    tooltip: ' = average_increase_in_taxes_per_year / 12',
                    getComputedValue(tabs, precomputedValues) {
                        const averageIncreaseInTaxesPerYear = tabs['property-information-tab'].tables['other-information'].rows['average-increase-in-taxes-per-year'].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((averageIncreaseInTaxesPerYear / 12).toFixed(2));
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'taxes-cannot-pass-to-tenants': {
                    name: 'Taxes-cannot Pass to tenants',
                    editable: false,
                    tooltip: ' = increase_in_taxes * (vacancy + total_prorata_share_tenants_not_reimbursing_property_taxes)',
                    getComputedValue(tabs, precomputedValues) {
                        const increaseInTaxes = tabs['property-information-tab'].tables['other-information'].rows['increase-in-taxes'].getComputedValue(tabs, precomputedValues).internalValue;
                        const vacancy = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['second-row'].valueCells[0].getComputedValue(tabs, '', precomputedValues).internalValue;
                        let totalProrataNonReimbursingTaxes = 0;
                        const reimbTab = 'current-reimbursement-tab';
                        const rrTab = 'current-rr-tab';
                        const rows = tabs[reimbTab].tables['detailed-information'].rows;
                        Object.keys(rows).forEach((i) => {
                            const giRow = tabs[rrTab].tables['general-information'].rows[i];
                            const tenantName = giRow && giRow.valueCells[1] ? String(giRow.valueCells[1].value).trim() : '';
                            if (tenantName === 'Vacant' || tenantName === 'vacant') {
                                return;
                            }
                            const reimbType = reimbursementTypeRowForCode(tabs, reimbTab, rows[i].valueCells[reimbCodeIndex].value);
                            if (!reimbType || reimbType.valueCells[taxesCheckboxCellIndex].value) {
                                return;
                            }
                            totalProrataNonReimbursingTaxes += rows[i].valueCells[prorataShareIndex].getComputedValue(tabs, i, precomputedValues).internalValue;
                        });
                        const value = parseFloat((increaseInTaxes * (vacancy / 100 + totalProrataNonReimbursingTaxes / 100)).toFixed(2));
                        const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
                'loss-in-value-due-to-taxes': {
                    name: 'Loss in Value Due to Tax Increase',
                    editable: false,
                    tooltip: ' = taxes_cannot_pass_to_tenants / cap_rate',
                    getComputedValue(tabs, precomputedValues) {
                        const taxesCannotPassToTenants = tabs['property-information-tab'].tables['other-information'].rows['taxes-cannot-pass-to-tenants'].getComputedValue(tabs, precomputedValues).internalValue;
                        const capRate = tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[2].value;
                        const value = parseFloat((taxesCannotPassToTenants / (capRate / 100)).toFixed(2));
                        const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    },
                },
            }
        },
        'links': {
            name: 'LINKS',
            rows: {
                'google-maps-link': {
                    name: 'Google Maps Link',
                    type: 'link',
                    editable: true,
                    value: ''
                },
                'tax-assessment-link-1': {
                    name: 'CAD Link',
                    type: 'link',
                    editable: true,
                    value: ''
                },
                'tax-assessment-link-2': {
                    name: 'CAD Link',
                    type: 'link',
                    editable: true,
                    value: ''
                },
                'tax-assessment-link-3': {
                    name: 'CAD Link',
                    type: 'link',
                    editable: true,
                    value: ''
                },
                'tax-assessment-link-4': {
                    name: 'CAD Link',
                    type: 'link',
                    editable: true,
                    value: ''
                },
            }
        },
        'parcel': {
            name: 'PARCELS',
            rows: {
                'parcel': {
                    name: 'Parcel',
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Parcel'}
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs) {
                            return {displayValue: 'Assessed Value'}
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs) {
                            return {displayValue: 'Tax Liability'}
                        }
                    }]
                },
                'tax-assessment-1': {
                    valueCells: [{
                        type: 'text',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }]
                },
                'tax-assessment-2': {
                    valueCells: [{
                        type: 'text',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }]
                },
                'tax-assessment-3': {
                    valueCells: [{
                        type: 'text',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }]
                },
                'tax-assessment-4': {
                    valueCells: [{
                        type: 'text',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }]
                },
                'total': {
                    name: 'Total',
                    valueCells: ([...new Array(3)]).map((el, index) => {
                        if (index === 0) {
                            return {
                                editable: false,
                                getComputedValue(tabs, precomputedValues) {
                                    return {displayValue: 'Total'}
                                }
                            }
                        }

                        return {
                            editable: false,
                            getComputedValue(tabs, precomputedValues) {
                                const parcelRows = tabs['property-information-tab'].tables['parcel'].rows;
                                const taxAssessments = [...new Array(4)].map((el, i) => {
                                    const taxAssessmentKey = `tax-assessment-${i + 1}`;
                                    if (parcelRows.hasOwnProperty(taxAssessmentKey)) {
                                        return parcelRows[taxAssessmentKey].valueCells[index].value || 0;
                                    }
                                });
                                const value = taxAssessments.reduce((a, b) => (parseFloat(a) + parseFloat(b)));
                                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                                return {internalValue: value, displayValue: displayValue}
                            }
                        }
                    })
                },
                'mill-rate-per-sq-ft': {
                    name: 'Total Taxes/Sq Ft',
                    valueCells: ([...new Array(3)]).map((el, index) => {
                        if (index === 0)
                            return {
                                editable: false,
                                getComputedValue() {
                                    return {displayValue: 'Total Taxes/Sq Ft'}
                                }
                            };

                        if (index === 1)
                            return {
                                editable: false,
                                getComputedValue() {
                                    return {displayValue: ''}
                                }
                            };

                        return {
                            editable: false,
                            tooltip: ' = total / total_sq_ft',
                            getComputedValue(tabs, precomputedValues) {
                                const millRateTotal = tabs['property-information-tab'].tables['parcel'].rows['total'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                                const totalSqFt = tabs['property-information-tab'].tables['other-information'].rows['total-sq-ft'].getComputedValue(tabs, precomputedValues).internalValue;
                                const value = parseFloat((millRateTotal / totalSqFt).toFixed(2));
                                const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString()}`;
                                return {internalValue: value, displayValue: displayValue}
                            }
                        }
                    })
                },
            }
        }
    }
}